import { isArray, values } from "lodash";

export const getAuditData = (audit: any) => {
    if (audit?.data?.items && !isArray(audit?.data?.items)) {
        const items = values(audit.data.items);
        return {
            ...audit,
            data: {
                items: items.map((item) => {
                    return { ...item, guests: values(item.guests) };
                }),
            },
        };
    }

    return audit;
};
